/**
 * Get current language on page load
 * @author Lina Arroyo <lina.arroyo@gradiweb.com>
 */

let currentLang;
window.onload = function () {
  currentLang = document.getElementsByTagName('html')[0].getAttribute('lang');
};

const currentLangNow = () => {
  return window.Shopify.locale;
};
export { currentLang, currentLangNow };
